module.exports = __webpack_public_path__ + "media/images/home/cellu_avant_apres-dc5447755144bc83bdef551daadd1b20.jpg";